export class PartnerMobileHover {
    private isMobile = window.innerWidth < 992;
    private partnerEntries: NodeListOf<HTMLElement>;
    public constructor() {
        this.partnerEntries = document.querySelectorAll(".partner__entry");

        window.addEventListener("resize", () => {
            if (this.isMobile && window.innerWidth >= 992) {
                this.isMobile = false;
            }
            if (!this.isMobile && window.innerWidth < 992) {
                this.isMobile = true;
            }
        });

        this.setActivePartner();
    }

    private setActivePartner = () => {
        window.addEventListener("scroll", () => {
            this.partnerEntries.forEach((partner) => {
                const rect = partner.getBoundingClientRect();
                if (
                    rect.top < window.innerHeight / 2 + rect.height / 2 &&
                    rect.top > window.innerHeight / 2 - rect.height / 2
                ) {
                    if (this.isMobile) {
                        partner.classList.add("active");
                    }
                } else {
                    partner.classList.remove("active");
                }
            });
        });
    };
}
